"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isWordPress;

var _getLeadinConfig = _interopRequireDefault(require("./getLeadinConfig"));

function isWordPress() {
  try {
    window.hubspot = window.hubspot || {};
    window.hubspot.wordpress = false;

    if (window.top !== window) {
      var leadinConfig = (0, _getLeadinConfig.default)();
      window.hubspot.wordpress = !!leadinConfig.wpVersion;
      return window.hubspot.wordpress;
    }
  } catch (e) {//
  }

  return false;
}

module.exports = exports.default;